import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(deprecated_page_names)/site-view/$siteID'
)({
  component: RouteComponent,
  loader: ({ params }) => {
    throw redirect({
      to: '/overview/{-$siteID}',
      params: {
        siteID: params.siteID,
      },
    })
  },
})

function RouteComponent() {
  return <div>Redirecting to overview...</div>
}
